enum OrderResponseStatus {
  ok = "有",
  no = "無",
  yet = "未",
}

export default OrderResponseStatus;
